import ApiClient from "./ApiClient";
import SubscriptionPlan, { CheckoutSessionRequest, CheckoutSessionResponse } from "../types/Subscription";

// API URL from environment variables
const API_URL = process.env.REACT_APP_SUBSCRIPTION_API_URL ?? "";

// Create an instance of ApiClient
const apiClientInstance = new ApiClient(API_URL);
const apiClient = apiClientInstance.getClient();

export const getALaCarteSubscriptions = async (): Promise<SubscriptionPlan[]> => {
    try {
        const response = await apiClient.get("/subscriptions/a-la-carte");
        return response.data;
    } catch (error) {
        console.error("Error fetching a la carte subscriptions:", error);
        throw error;
    }
};

export const getAnnualSubscriptions = async (): Promise<SubscriptionPlan[]> => {
    try {
        const response = await apiClient.get("/subscriptions/annual");
        return response.data;
    } catch (error) {
        console.error("Error fetching annual subscriptions:", error);
        throw error;
    }
};

export const createCheckoutSession = async (
    organizationId: string,
    planId: string,
    successUrl: string,
    cancelUrl: string,
    isSubscription: boolean = false
): Promise<CheckoutSessionResponse> => {
    try {
        const checkoutRequest: CheckoutSessionRequest = {
            organization_id: organizationId,
            plan_id: planId,
            success_url: successUrl,
            cancel_url: cancelUrl,
            is_subscription: isSubscription
        };

        const response = await apiClient.post("/checkout/create-checkout-session", checkoutRequest);
        return response.data;
    } catch (error) {
        console.error("Error creating checkout session:", error);
        throw error;
    }
};

export const verifyCheckoutSession = async (
    sessionId: string
): Promise<{ success: boolean, organization_id?: string, subscription_id?: string }> => {
    try {
        const response = await apiClient.get(`/checkout/verify-session/${sessionId}`);
        return response.data;
    } catch (error) {
        console.error("Error verifying checkout session:", error);
        throw error;
    }
};

export const getOrganizationSubscription = async (
    organizationId: string
): Promise<SubscriptionPlan> => {
    try {
        const response = await apiClient.get(`/n/${organizationId}/subscription`);
        return response.data;
    } catch (error) {
        console.error("Error fetching subscription:", error);
        throw error;
    }
};

// Export all API methods as default
const subscriptionService = {
    getALaCarteSubscriptions,
    getAnnualSubscriptions,
    createCheckoutSession,
    verifyCheckoutSession
};

export default subscriptionService;